;
(function(){
  // Sticky bar
  var sticky = document.getElementById('bs2Sticky');
  if(sticky){
    var shown = false;
    function checkScroll(){
      var p = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
      if(p > 0.12 && !shown){ sticky.classList.add('bs2-sticky-visible'); shown = true; }
    }
    window.addEventListener('scroll', checkScroll, {passive:true});
    checkScroll();
  }
  // FAQ accordions
  var faqBtns = document.querySelectorAll('.bs2-faq-q');
  for(var i = 0; i < faqBtns.length; i++){
    faqBtns[i].addEventListener('click', function(){
      var a = this.nextElementSibling;
      var arrow = this.querySelector('.bs2-faq-arrow');
      if(a.style.display === 'block'){
        a.style.display = 'none';
        if(arrow) arrow.style.transform = 'rotate(0deg)';
      } else {
        a.style.display = 'block';
        if(arrow) arrow.style.transform = 'rotate(45deg)';
      }
    });
  }
  // Video posters
  var posters = document.querySelectorAll('.bs2-vt-poster');
  for(var j = 0; j < posters.length; j++){
    posters[j].addEventListener('click', function(){
      var v = this.querySelector('video');
      var im = this.querySelector('img');
      var pl = this.querySelector('.bs2-vt-play');
      var tg = this.querySelector('.bs2-vt-tag');
      if(v){ v.style.display = 'block'; v.play(); }
      if(im) im.style.display = 'none';
      if(pl) pl.style.display = 'none';
      if(tg) tg.style.display = 'none';
    });
  }
})();
